import { isEngageAppEmbedView } from './isEngageAppEmbedView';
import { isVivaConnectionsApp } from './isVivaConnectionsApp';

type IsMobileEmbedView = () => boolean;
export const isMobileEmbedView: IsMobileEmbedView = () => isVivaConnectionsApp() || isEngageAppEmbedView();
